import { requests } from './agent'
import { HttpResponse } from '../models/http/Reponse'
import { Auction } from '../models/Auction'
import { Log, LogBase } from '../models/Log'
import { Post } from '../models/Post'

interface AuctionListResponse extends HttpResponse {
  data: Auction[]
}

interface LogListResponse extends HttpResponse {
  data: Log[]
}
interface PostListResponse extends HttpResponse {
  data: Post[]
}

const ActivityPanel = {
  myActivity: () => requests.get<AuctionListResponse>('Activity'),
  participating: () => requests.get<AuctionListResponse>('Activity/participating'),
  wins: () => requests.get<AuctionListResponse>('Activity/wins'),
  logs: () => requests.get<LogListResponse>('Logs/user'),
  addLog: (log: LogBase) => requests.post<HttpResponse>('Logs', log),
  myPosts: () => requests.get<PostListResponse>('Activity/myPosts'),
}

export default ActivityPanel
